import '@ICubePlugins/resize-nav';

function initBodyCover($view) {
    if (!ICube.data.get('hasTouchEvents')) {
        const $bodyCover = $view.find('.js-body-cover');

        if ($bodyCover.length) {
            import(MODULES_PATH + 'body-cover').then(BodyCover => {
                BodyCover.init.call($bodyCover, {
                    parent: $view,
                    showCover: function($trigger) {
                        /* wyświetlamy tylko jeśli koszyk nie jest pusty (w strukturze znajduje się is-card) */
                        return $trigger.find('.is-card').length;
                    }
                });
            });
        }
    }
}

function initProductsStorageCounters($view) {
    const $wishlist = $view.find('.js-header-wishlist');
    const $comparison = $view.find('.js-header-comparison');
    let addStorageUpdateEvent = false;

    if ($wishlist.length) {
        import(MODULES_PATH + 'products-storage').then(ProductsStorage => {
            ProductsStorage.getData.call($wishlist, 'wishlist', function(storageData) {
                if (storageData !== 'STORAGE_UNAVAILABLE') {
                    if (storageData.length) {
                        $wishlist.find('.js-wishlist-counter').text(storageData.length);
                        $wishlist.removeClass('is-hidden');
                    }
                }
            })
        });

        addStorageUpdateEvent = true;
    }

    if ($comparison.length) {
        import(MODULES_PATH + 'products-storage').then(ProductsStorage => {
            ProductsStorage.getData.call($comparison, 'comparison', function(storageData) {
                if (storageData !== 'STORAGE_UNAVAILABLE') {
                    if (storageData.length) {
                        $comparison.find('.js-comparison-counter').text(storageData.length);
                        $comparison.removeClass('is-hidden');
                    }
                }
            });
        });

        addStorageUpdateEvent = true;
    }

    if (addStorageUpdateEvent) {
        $(document).on('icube.products.storage.update icube.products.storage.dataset', function(event, key, storageData) {
            switch (key) {
                case 'wishlist':
                    if (storageData.length) {
                        $wishlist.find('.js-wishlist-counter').text(storageData.length);
                        $wishlist.removeClass('is-hidden');
                    } else {
                        $wishlist.addClass('is-hidden');
                    }
                    break;
                case 'comparison':
                    if (storageData.length) {
                        $comparison.find('.js-comparison-counter').text(storageData.length);
                        $comparison.removeClass('is-hidden');
                    } else {
                        $comparison.addClass('is-hidden');
                    }
                    break;
            }
        });
    }
}

function initLazyComparison($view) {
    const $lazyComparison = $('#vHeader-lazyComparison');
    let firstRenderFinished = false;

    if ($lazyComparison.length) {
        const mouseenterInitialHandler = function() {
            import(MODULES_PATH + 'products-storage').then(ProductsStorage => {
                ProductsStorage.getData.call($lazyComparison, 'comparison', function(storageData) {
                    if (storageData !== 'STORAGE_UNAVAILABLE' && storageData.length) {
                        /* inicjujemy lazyHtml jeśli w storage są dane */
                        $lazyComparison.icubeLazyHtml({
                            src: ICUBE_CONFIG.domain + 'index.php?endpoint=publicarea&package=assortment&controller=products&action=comparisonlisting&mode=simple',
                            method: 'POST',
                            body: {txt_ids: storageData},
                            keepDimensions: false,
                            allowEmptyHtml: false,
                            beforeRender: function($el) {
                                $el.find('.is-card').remove();
                            },
                            afterRender: function($el) {
                                $(document).off('icube.products.storage.update icube.products.storage.dataset');
                                initProductsStorageCounters($view);

                                if (!firstRenderFinished) {
                                    firstRenderFinished = true;

                                    setTimeout(function() {
                                        $lazyComparison.on('mouseenter', function() {
                                            if (ICube.data.get('comparisonChanged')) {
                                                ProductsStorage.getData('comparison', function(storageData) {
                                                    if (storageData !== 'STORAGE_UNAVAILABLE') {
                                                        $lazyComparison.trigger('icube.lazyhtml.refresh', [{body: {txt_ids: storageData}}]);
                                                        ICube.data.set('comparisonChanged', false);
                                                    }
                                                });
                                            }
                                        });
                                    }, 500);
                                }
                            }
                        });
                    } else {
                        $lazyComparison.one('mouseenter', mouseenterInitialHandler);
                    }
                })
            });
        };

        $view.on('click', '.js-comparison-simple-remove', function() {
            const $self = $(this);

            $self.closest('.js-product-row').remove();

            import(MODULES_PATH + 'products-storage').then(ProductsStorage => {
                ProductsStorage.removeData('comparison', $self.data('id'), function(storageData) {
                    if (storageData !== 'STORAGE_UNAVAILABLE') {
                        $(document).trigger('icube.products.storage.update', ['comparison', storageData]);
                        $(document).trigger('icube.view.header.comparisonremoved');

                        if (!storageData.length) {
                            $lazyComparison.find('.is-card').remove();
                        }
                    }
                });
            });
        });

        $lazyComparison.one('mouseenter', mouseenterInitialHandler);
    }
}

function initLazyHtml($view) {
    $view.find('.js-v-header-lazy-html').icubeLazyHtml(
        $.extend(true, {}, ICube.data.get('defaultLazyHtmlConfig'), {
            keepDimensions: false,
            beforeRequest: function($el) {
                const loader = $el.data('loader');

                loader.$loader.find('img').attr('src', ICUBE_CONFIG.static_domain + 'assets/publicarea/images/tail-spin-black.svg');
                loader.show();
            },
            afterRender: function($el) {
                $el.find('.js-prev-menu-btn').on('click', function() {
                    $(this).closest('.is-open').removeClass('is-open');
                });

                const $removeFromCart = $el.find('.js-remove-from-cart');
                if ($removeFromCart.length) {
                    import(MODULES_PATH + 'cart').then(Cart => Cart.remove.call($removeFromCart));
                }

                $el.data('loader').hide();
            }
        })
    );
}

function initResponsiveEvents($view) {
    const $window = $(window);
    const $body = $('body');
    const $menu = $('#vHeader-menu');
    const $menuTrigger = $('#vHeader-menuTrigger');

    $menuTrigger.on('click', function() {
        $body.toggleClass('lock');
        $menuTrigger.toggleClass('is-active');
        $menu.toggleClass('is-open');
        $menu.find('.is-open').removeClass('is-open');
        $view.find('.is-card').removeClass('is-open');
        $view.find('[data-card]').removeClass('has-open-card');
    });

    $view.find('.js-submenu-trigger').each(function() {
        const $trigger = $(this);
        let $submenu = null;

        if ($trigger.data('submenu')) {
            $submenu = $($trigger.data('submenu'));
        } else {
            $submenu = $trigger.next('.js-submenu').first();
        }

        $trigger.on('click', function(e) {
            if ($window.width() <= 1024) {
                e.preventDefault();
                $submenu.toggleClass('is-open');
            }
        });
    });

    $view.find('.js-prev-menu-btn').on('click', function() {
        $(this).closest('.is-open').removeClass('is-open');
    });

    $view.find('.js-card-trigger').on('click', function() {
        const $self = $(this);
        const $targetCard = $($self.data('card'));
        const $cardsToClose = $view.find('.is-card').not($targetCard).filter('.is-open');

        $cardsToClose.each(function() {
            const $cardTrigger = $view.find('[data-card="#' + $(this).attr('id') + '"]');
            $cardTrigger.removeClass('has-open-card');
        });
        $cardsToClose.removeClass('is-open');

        $view.find('[data-card="#' + $targetCard.attr('id') + '"]').toggleClass('has-open-card');
        $targetCard.toggleClass('is-open');
    });

    /* element dynamiczny (lazy html) */
    $(document).on('click', '#vHeader-userMenuTrigger', function(e) {
        if ($('body').width() < 1024) {
            e.preventDefault();
            $view.find('.js-card-trigger[data-card="#vHeader-userCard"]').trigger('click');
        }
    });

    $window.on('resize', function() {
        if ($window.width() > 1023 && $menuTrigger.hasClass('is-active')) {
            $menuTrigger.trigger('click');
        }
    });
}

function initProductAutosearch($view) {
    import(ICUBE_PRODUCT_AUTOSEARCH).then(() => {
        ICube.plugins.ProductAutosearch({
            url: ICUBE_CONFIG.domain + '?endpoint=publicarea&package=assortment&controller=products&action=search',
            noResultsTemplate: function() {
                if ($('body').width() <= 1023) {
                    return `<div class="w-100p px-20"><p class="text-center">${__('no_search_results')}.</p></div>`;
                }

                return '';
            },
            onClear: function(instance, params) {
                if (!params.lastValue) {
                    $view.find('.js-card-trigger[data-card="#vHeader-productSearch"]').first().trigger('click');
                }
            }
        });
    });
}

function initResize($view) {
    $view.ciResizeNav({
        stickyClass: 'is-sticky',
        hideClass: 'is-hidden'
    });
}

export default function() {
    const $view = $(this);

    if ($view.length) {
        initResize($view);
        initProductAutosearch($view);
        initResponsiveEvents($view);
        initLazyHtml($view);
        initLazyComparison($view);
        initProductsStorageCounters($view);
        initBodyCover($view);
    }
}